import { CountryLanguageZ } from '@/types/languages'

import { getGGClient, RequestOverrides } from './GetGoingClient'

export async function getLanguages(overrides?: RequestOverrides) {
	return getGGClient()
		.request('GET', 'countries/languages', {
			responseSchema: CountryLanguageZ.array(),
			...overrides,
		})
		.then((r) => r.data)
}
